import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

import "animate.css";
import scroll from "vue-seamless-scroll";

import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/css/swiper.css";

// import "./assets/style/style.scss"; //引入全局样式

Vue.use(ElementUI);
Vue.use(scroll);
Vue.use(VueAwesomeSwiper);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
